import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tangram-curator-assistant-panel',
  templateUrl: './curator-assistant-panel.component.html',
  styleUrls: ['./curator-assistant-panel.component.scss']
})
export class CuratorAssistantPanelComponent {
  @Input() topic: string = '';
  @Input() stepIndex: number = 1;
  @Input() isLoading: boolean = false;
  @Input() errorMessage: string = '';
  @Input() isEnhanceMode: boolean = false;
  @Input() draft: { title: string; description: string; notes: string[] } = { title: '', description: '', notes: [] };
  @Input() modules: Array<{ title: string; summary: string; selected: boolean }> = [];
  @Input() suggestedContent: Array<{ title: string; url: string; reason: string; source: string; selected: boolean }> = [];
  @Input() missingTopics: string[] = [];
  @Input() sequenceImprovements: string[] = [];

  @Output() topicChange = new EventEmitter<string>();
  @Output() generate = new EventEmitter<void>();
  @Output() applyDraft = new EventEmitter<void>();
  @Output() setStep = new EventEmitter<number>();
  @Output() toggleModule = new EventEmitter<number>();
  @Output() toggleContent = new EventEmitter<number>();
  @Output() useContent = new EventEmitter<{ title: string; url: string }>();

  get hasGeneratedPlan(): boolean {
    return !!(
      (this.draft && (this.draft.title || this.draft.description))
      || (this.modules && this.modules.length)
      || (this.suggestedContent && this.suggestedContent.length)
      || (this.missingTopics && this.missingTopics.length)
      || (this.sequenceImprovements && this.sequenceImprovements.length)
    );
  }

  get selectedModuleCount(): number {
    return (this.modules || []).filter((item) => !!item.selected).length;
  }

  get selectedContentCount(): number {
    return (this.suggestedContent || []).filter((item) => !!item.selected).length;
  }

  jumpToStep(stepNumber: number): void {
    if (stepNumber < 1 || stepNumber > 3) {
      return;
    }
    this.setStep.emit(stepNumber);
  }

  onGenerateClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.generate.emit();
  }

  onApplyDraftClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.applyDraft.emit();
  }

  onSetStepClick(event: Event, stepNumber: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.jumpToStep(stepNumber);
  }
}
